<div class="bc-search-widget">
  <div class="bc-layout-wrapper" [hidden]="search.isSearching">
    <div class="bc-panel-maxh" [ngClass]="{ 'bc-search-filters-hidden': resultsVisible }">
      <app-info-label *ngIf='isHybrid'>{{ 'bcSearchWidget.searchNotIncludeCX' | translate }}</app-info-label>
      <app-search-box [searchObject]="search" [(resultsVisible)]="resultsVisible"></app-search-box>
    </div>
    <div class="bc-panel-maxh" [ngClass]="resultsVisible ? 'bc-search-results-visible' : 'bc-search-results-hidden'">
      <app-search-results-panel *ngIf="resultsVisible" [searchObject]="search" [(resultsVisible)]="resultsVisible"></app-search-results-panel>
    </div>
  </div>

  <div class="bc-layout-wrapper" *ngIf="search.isSearching">
    <div class="bc-empty-screen text-center">
      <app-loading heading="{{ 'bcSearchWidget.waitTitle' | translate: search }}"
                   [description]="'bcSearchWidget.waitDescription'"
                   [hover]="'bcSearchWidget.waitHover' | translate: search"></app-loading>
    </div>
  </div>
</div>
